import { Injectable } from '@angular/core';
import { Http, Response, RequestOptionsArgs, Headers } from '@angular/http';
import {Observable} from 'rxjs/Rx';
import { AppConfigValues } from '../shared/app-config-values';
import { AuthService } from '../authentication/auth.service';

@Injectable()
export class HttpHelper {
    urlPrefix: string;
   
    constructor(private http: Http,
        private config: AppConfigValues,
        private authService: AuthService) {
        this.urlPrefix = config.getApiHostUrl();
    }
    
     public get(url: string) : Observable<any> {

        let headers = new Headers();
        
        if(this.authService.isLoggedIn()){
            
            headers.append('Authorization', `Bearer ${this.authService.getAccessToken()}`);
        }
        
         return this.http.get(this.urlPrefix +url, { headers })
            .map(this.extractData)
            .do(data => console.log(data))
            .catch(this.handleError);
     }

     public post(url: string, body: any, options?: RequestOptionsArgs) : Observable<any>{
        let headers = new Headers({'Content-Type': 'application/json'});
        
        if(this.authService.isLoggedIn()){
            headers.append('Authorization', `Bearer ${this.authService.getAccessToken()}`);
        }
        
       
        let postOptions = options || {headers : headers }

        return this.http.post(this.urlPrefix + url, body, postOptions)
            .map(this.extractData)
            .do(data => console.log(" data " + data))
            .catch(this.handleError);
     }

     
     public put(url: string, body: any, options?: RequestOptionsArgs) : Observable<any>{
        
        let headers = new Headers({'Content-Type': 'application/json'});
        
        if(this.authService.isLoggedIn()){
            
            headers.append('Authorization', `Bearer ${this.authService.getAccessToken()}`);
        }
        

        let postOptions = options || {headers : headers }

        
        return this.http.put(this.urlPrefix + url, body, postOptions)
            .map(this.extractData)
            .do(data => console.log(data))
            .catch(this.handleError);
     }


     public delete(url: string, options?: RequestOptionsArgs) : Observable<any>{
        //not sure if I actually need the headers and options here 

        //let headers = new Headers({'Content-Type': 'application/json'});
        //let postOptions = options || {headers : headers }
        
        //return this.http.delete(this.urlPrefix + url, postOptions)
        let headers = new Headers();

        if(this.authService.isLoggedIn()){
            
            headers.append('Authorization', `Bearer ${this.authService.getAccessToken()}`);
        }
        

        return this.http.delete(this.urlPrefix + url, { headers })
            .map(this.extractData)
            .do(data => console.log(data))
            .catch(this.handleError); 
     }

     private extractData(res: Response) {
           let body: any;

            // check if empty, before call json
            if (res.text()) {
                body = res.json();
            }

            return body || {};
    }

    private handleError(error: any) {        
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        console.error(errMsg); 
        return Observable.throw(errMsg);
    }
}


/** WEBPACK FOOTER **
 ** ./app/shared/http-helper.ts
 **/